import React, { useEffect } from "react";
import { useState } from "react";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import OrderSummary from "../../../components/DashboardComponents/OrderSummary/OrderSummary";
// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import Wrapper from "../../../components/UI/Wrapper";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import icon_user from "../../../Icons/icon_user.png";
import axios from "axios";
import TwoLevelPieChartUsers from "../../../components/DashboardComponents/TwoLevelPieChart/TwoLevelPieChartUsers";
import ShipmentData from "../../../components/DashboardComponentAccounts/ShipmentData/ShipmentData";
import RevenueData from "../../../components/DashboardComponentAccounts/RevenueData/RevenueData";

const Dashboard = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {    

     
    }
  }, []);

 
  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid wholeContainer"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            ></div>

            <div>
              <div className="datattat" style={{ width: "100%" }}>
                <ShipmentData />
              </div>

              <div className="datattat" style={{ width: "99%" }}>
              <RevenueData/>
              </div>
        
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
